import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JsonHttpService } from 'src/app/shared/http/json-http.service';
import { SentMail } from '../models/sent-mail';

@Injectable({
  providedIn: 'root'
})
export class SentMailService {
  private http = inject(JsonHttpService);

  get(from?: Date, to?: Date, top?: number): Observable<SentMail[]> {
    const options = { params: new HttpParams() };

    if (from) {
      options.params = options.params.set('from', from.toISOString());
    }
    if (to) {
      options.params = options.params.set('to', to.toISOString());
    }
    if (top) {
      options.params = options.params.set('top', top);
    }

    return this.http.getTyped<SentMail[]>('/api/sentmails/get-log', options).pipe(
      map((res: SentMail[]) => res.map((val: SentMail) => ({ ...val, Timestamp: new Date(val.Timestamp) }) as SentMail))
    );
  }
}
